import Schoolyear from "../views/schooladmin/Schoolyear";
import SchoolyearAddEdit from "../views/schooladmin/SchoolyearAddEdit";

export default [
	{
		path: "/schooladmin/schoolyear",
		meta: { requiresPortalAdmin: true },
		components: {
			content: Schoolyear
		}
	},
	{
		path: "/schooladmin/schoolyear/new",
		meta: { requiresPortalAdmin: true },
		components: {
			content: SchoolyearAddEdit
		}
	},
	{
		path: "/schooladmin/schoolyear/update/:id",
		meta: { requiresPortalAdmin: true },
		components: {
			content: SchoolyearAddEdit
		},
		props: {
			content: true
		}
	}
];
